import styled from "styled-components";
import { device } from "../../../../globalStyles/breakpoints";

export const RetailMatchIntroGrid = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  grid-template-columns: 454px 1fr;
  grid-column-gap: 70px;
  grid-template-rows: auto;
  padding: 15px 0;

  ${device.desktop} {
    padding: 25px 0;
    display: grid;
    justify-content: center;
    align-content: center;
  }
`;

export const IntroGridBlockTwo = styled.div`
  display: grid;
  border-radius: 8px;
  grid-template-columns: repeat(4, 22.75%);
  grid-column-gap: 3%;
  grid-auto-rows: 1fr;
  grid-row-gap: 24px;

  ${device.desktop} {
    grid-template-columns: repeat(4, 101px);
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
  }
`;

export const IntroGridContentBlockOne = styled.div`
  width: 100%;
`;
